/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getAppBannerList: (params) => {
    return axios.get(API_ENDPOINTS.GET_APP_BANNERS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getAppBannerById: (id) => {
    return axios.get(API_ENDPOINTS.GET_APP_BANNER_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addAppBanner: (data) => {
    return axios.post(API_ENDPOINTS.ADD_APP_BANNER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateAppBanner: (id, data) => {
    const url = API_ENDPOINTS.UPDATE_APP_BANNER_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteAppBanner: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_APP_BANNER_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
